import { createContext } from 'react'
const SegmentContext = createContext('Default Value')
export default SegmentContext
